import { render } from "./IdeaList.vue?vue&type=template&id=4c277d21&scoped=true"
import script from "./IdeaList.vue?vue&type=script&lang=js"
export * from "./IdeaList.vue?vue&type=script&lang=js"

import "./IdeaList.vue?vue&type=style&index=0&id=4c277d21&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c277d21"]])

export default __exports__